import { render, staticRenderFns } from "./component-ebbdd2bb.vue?vue&type=template&id=36664bd6&scoped=true&"
import script from "./component-ebbdd2bb.vue?vue&type=script&lang=js&"
export * from "./component-ebbdd2bb.vue?vue&type=script&lang=js&"
import style0 from "./component-ebbdd2bb.vue?vue&type=style&index=0&id=36664bd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36664bd6",
  null
  
)

export default component.exports